<template>
  <v-main>
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <div style="position: relative;">
        <v-btn
          v-if="readOnly"
          absolute
          fab
          top
          right
          dark
          color="primary"
          @click="editItem"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </div>
      <br />
      <br />
      <form>
        <v-row dense>
          <v-col cols="12" sm="6" md="6" class="pr-4">
            <v-img
              v-if="visi_misi.foto_url_original"
              :src="visi_misi.foto_url"
              contain
              :key="visi_misi.fotoKey"
              max-height="300"
            ></v-img>
            <v-img
              v-else
              src="@/assets/empty_image.png"
              contain
              max-height="300"
            ></v-img>
            <v-file-input
              class="mt-4"
              outlined
              @change="loadImage"
              accept="image/*"
              v-model="visi_misi.poster_url"
              prepend-icon="mdi-image"
              show-size
              label="Gambar"
              :disabled="readOnly"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  rows="5"
                  label="Visi"
                  v-model="visi_misi.visi"
                  :outlined="outlined"
                  :readonly="readOnly"
                  dense
                  :hide-details="hideDetails"
                  placeholder="Konten"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  rows="8"
                  label="Misi"
                  v-model="visi_misi.misi"
                  :outlined="outlined"
                  :readonly="readOnly"
                  dense
                  :hide-details="hideDetails"
                  placeholder="Konten"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="!readOnly">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn @click="doBatal" style="margin-right: 10px;">Batal</v-btn>
            <v-btn dark color="primary" type="submit" @click.prevent="doSubmit"
              >Simpan</v-btn
            >
          </v-col>
        </v-row>
      </form>
    </v-container>
  </v-main>
</template>

<script>
import VisiMisiService from "../../services/web_content/VisiMisiService";
import CommonService from "../../services/CommonService";

export default {
  name: "VisiMisi",
  components: {},
  props: {},
  data: () => ({
    breadcrumbs: [
      {
        text: "Visi Misi",
        disabled: false,
        exact: true,
        to: { name: "VisiMisi" },
      },
      { text: "Detail", disabled: true },
    ],
    readOnly: true,
    visi_misi: {
      id: 0,
      foto_url_original: null,
      foto_url: null,
      fotoKey: 0,
      poster_url: null,
      visi: "",
      misi: "",
    },
  }),
  computed: {
    outlined() {
      return this.readOnly;
    },
    hideDetails() {
      return true;
    },
  },
  mounted: async function() {
    this.fetch();
  },
  methods: {
    loadImage: function(data) {
      console.log("loadImage:", data);
      if (data) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.visi_misi.foto_url = e.target.result;
          this.visi_misi.foto_url_original = this.visi_misi.foto_url;
          this.visi_misi.fotoKey++;
        };
        reader.readAsDataURL(data);
      }
    },
    fetch: async function() {
      try {
        console.log("fetch");
        VisiMisiService.visiMisi()
          .then((res) => {
            this.visi_misi = res.data.visi_misi;
            console.log(this.visi_misi);
            console.log(this.visi_misi.id);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (e) {
        console.error("error:", e);
      }
    },

    editItem: async function() {
      this.readOnly = false;
    },

    doBatal: function() {
      this.readOnly = true;
    },

    doSubmit: async function() {
      try {
        console.log(this.visi_misi.id);
        if (this.visi_misi.id != null) {
          VisiMisiService.update(this.visi_misi)
            .then((res) => {
              console.log(res);
              CommonService.showSuccessToast("Update visi misi berhasil");

              this.fetch();
              this.readOnly = true;
            })
            .catch((err) => {
              console.log(err);
              CommonService.showErrorToast("Update visi misi gagal. Coba lagi");
            });
        } else {
          VisiMisiService.create(this.visi_misi)
            .then((res) => {
              console.log(res);
              this.dialog = false;
              CommonService.showSuccessToast("Tambah visi misi berhasil");

              this.getDataFromApi();
              this.readOnly = true;
            })
            .catch((err) => {
              console.log(err);
              CommonService.showErrorToast("Tambah visi misi gagal. Coba lagi");
            });
        }
      } catch (e) {
        console.error("error:", e);
      }
    },
  },
};
</script>

<style scoped></style>
